import type { LabeledValuePayload } from '@Application/Users/UserStatuses/Actions/userStatusesFetched';

export type AboutCandidatePayload = {
	readonly kind: LabeledValuePayload;
	readonly id: number;
	readonly name: string;
	readonly detail: string | null;
};

export type AboutCandidatesFetchedPayload = {
	search: string;
	candidates: AboutCandidatePayload[];
};

export type AboutCandidatesFetchedAction = {
	type: 'ABOUT_CANDIDATES_FETCHED';
	payload: AboutCandidatesFetchedPayload;
};

export default (search: string, candidates: AboutCandidatePayload[]): AboutCandidatesFetchedAction => ({
	type: 'ABOUT_CANDIDATES_FETCHED',
	payload: { search, candidates },
});
